/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business aC Men's Hub frontend entrypoint. Initializes Faro and mounts the React app.
 * @graph-connects none
 */
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'ac-mens-hub' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import './styles.css';
import './i18n';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
